//import store from '@/store';
//import ludwigImage from "@/assets/browsergame/ludwig.png";
import ludwigImage from "@/assets/browsergame/ludwig_sprite.png";

export class Ludwig {
  constructor(x, y, _X, ctx, nogo) {
    this.move = this.move.bind(this);
    //    this.animate = this.move.bind(this);
    this.canvasheight = 1080;
    this.defaultHeight = 600;
    this.defaultWidth = 360;
    this.moving = false;
    this.animation;
    this.xPos = Math.ceil(x * _X);
    this.yPos = Math.ceil(y * _X);
    this.xRel = x;
    this.yRel = y;
    this._X = _X;
    this.ctx = ctx;
    this.frameX = 0; // X-Position auf dem Sprite Sheet
    this.gameFrame = 0; // Zählt die Frames des Spiels
    this.setLudwig();
    this.nogo = nogo;
    this.isGivingAFuck = true;
    this.tempMove = false;
    this.xMoveToFinal = [];
    this.yMoveToFinal = [];
  }
  setRelation(relation) {
    this._X = relation;
  }
  setLudwig() {
    const self = this;
    this.image = new Image();
    this.image.src = ludwigImage;
    this.spriteWidth = 200; // Breite eines Sprite-Frame
    this.spriteHeight = 334; // Höhe eines Sprite-Frame
    this.direction = 0; //0 front / 1 left / 2 right / 3 back
    this.image.onload = () => {
      self.draw();
    };
  }
  draw(line = -1, column = -1) {
    this.frameX = line >= 0 ? line : this.frameX;
    this.direction = column >= 0 ? column : this.direction;

    this.ctx.drawImage(
      this.image,
      this.frameX * this.spriteWidth,
      this.direction * this.spriteHeight,
      this.spriteWidth,
      this.spriteHeight,
      this.xPos,
      this.yPos,
      this.width,
      this.height
    );
  }

  moveTo(x, y) {
    //calculate size of new Ludwig first
    // Ludwig hat etwas zu tun und gibt einen Fick
    this.tempMove = false;
    this.xMoveToFinal = [];

    this.isGivingAFuck = true;
    let h = this.canvasheight * this._X;
    let bottomDepth = (2 / h) * (this.yPos + this.height);
    let sizeOnBottom = this.calcPerspective(
      this.defaultHeight * this._X,
      bottomDepth
    );
    let relation = sizeOnBottom / this.height; // get relation between top and bottom y

    let newDepth = (2 / h) * y;
    let newSizeOnBottom = this.calcPerspective(
      this.defaultHeight * this._X,
      newDepth
    ); //getSize

    this.yMoveTo = y - newSizeOnBottom / relation;
    this.xMoveTo =
      x -
      Math.ceil(
        this.calcPerspective(
          this.defaultWidth * this._X,
          (2 / h) * this.yMoveTo
        ) / 2
      );
  }
  move() {
    //this.drawAll();
    this.moving = false;
    let change = { x: 0, y: 0 };

    //TODO: detect collision
    //TODO: add fuckit-timer to collision resolver
    if (
      this.xPos < this.xMoveTo - Math.ceil(this._X * 4) ||
      this.xPos > this.xMoveTo + Math.ceil(this._X * 4)
    ) {
      this.moving = true;
      if (this.xPos < this.xMoveTo) {
        //change Ludwigs X position
        change.x = Math.ceil(this._X * 2.5);
      } else {
        change.x = -Math.ceil(this._X * 2.5);
      }
    }
    if (
      this.yPos < Math.ceil(this.yMoveTo) - Math.ceil(this._X * 2) ||
      this.yPos > this.yMoveTo + Math.ceil(this._X * 2)
    ) {
      this.moving = true;
      if (this.yPos < this.yMoveTo) {
        //change Ludwigs Y position
        change.y = Math.ceil(this._X * 1);
      } else {
        change.y = -Math.ceil(this._X * 1);
      }
    }
    if (this.moving) {
      if (!this.canMoveTo(change)) {
        change = this.tryMoveTo(change);
      }
      if (change) {
        change = this.adjustWalkingSpeed(change);
        this.setDirection(change);
        let moveTo = this.calcNewPosition(change);

        this.xPos = moveTo.x;
        this.yPos = moveTo.y;
      } else {
        console.log("Ludwig hat keinen Bock mehr");
        if (this.tempMove) {
          console.log("tmpmove");
        } else {
          this.stop();
        }
      }
    } else {
      if (this.tempMove) {
        
        this.moving = true;
        this.yMoveTo = this.yMoveToFinal[this.yMoveToFinal.length - 1];
        this.yMoveToFinal.pop();
        this.xMoveTo = this.xMoveToFinal[this.xMoveToFinal.length - 1];
        this.xMoveToFinal.pop();
        if (this.yMoveToFinal.length<1){
          this.tempMove = false;
        }
      }
    }

    //TODO slow down for smaller displays (min 1px movement)
  }
  canMoveTo(change) {
    let moveTo = this.calcNewPosition(change);
    //Betritt Ludwig da etwa verbotenes Gebiet? Darf er das?
    let bottom = moveTo.y + this.height;
    let middle = moveTo.x + this.width / 2;
    for (let area of this.nogo) {
      //Ludwig schaut, ob sein Ziel in der nogo-Zone ist
      if (this.ctx.isPointInPath(area, middle, bottom)) {
        return false;
      }
    }
    return true;
  }
  tryMoveTo(change) {
    //Ludwig versucht erst nur den X oder Y Punkt zu erreichen
    let tryChange = { x: change.x, y: 0 };
    if (change.x != 0 && this.canMoveTo(tryChange)) {
      // Ludwig entscheidet sich nur horizontal zu gehen
      return tryChange;
    }
    tryChange = { x: 0, y: change.y };
    if (change.y != 0 && this.canMoveTo(tryChange)) {
      // Ludwig entscheidet sich nur vertikal zu gehen
      return tryChange;
    }
    // Ludwig schaut sich nach einer anderen Richtungen um, an das Ziel zu kommen.
    // Er schaut zuerst, ob der X oder Y Punkt weiter entfernt ist.
    let stepsAhead = false;
    if (
      Math.abs(this.xPos - this.xMoveTo) > Math.abs(this.yPos - this.yMoveTo)
    ) {
      // Ludwig setzt sich das Ziel, auf der weiter entfernten X-Achse 10 Pixel näher zu kommen.
      let goal = 0;
      if (this.xPos > this.xMoveTo) {
        goal = -30;
      } else {
        goal = 30;
      }
      // Ludwig versucht, auf der Y-Achse soweit zu gehen, bis er sich auf der X-Achse in die richtige Richtung bewegen kann.
      stepsAhead = this.findPath({ x: 0, y: this._X * 10 }, goal);
    } else {
      // Ludwig setzt sich das Ziel, auf der weiter entfernten Y-Achse 10 Pixel näher zu kommen.
      let goal = 0;
      if (this.yPos > this.yMoveTo) {
        goal = -30;
      } else {
        goal = 30;
      }
      // Ludwig versucht, auf der X-Achse soweit zu gehen, bis er sich auf der Y-Achse in die richtige Richtung bewegen kann.
      stepsAhead = this.findPath({ x: this._X * 10, y: 0 }, goal);
    }
    if (stepsAhead) {
      console.log(stepsAhead);
      this.tempMove = true;
      this.yMoveToFinal.push(this.yMoveTo);
      this.xMoveToFinal.push(this.xMoveTo);

      this.yMoveTo = this.yPos + stepsAhead.y;
      this.xMoveTo = this.xPos + stepsAhead.x;

      console.warn(this.xMoveTo, this.yMoveTo);
      console.warn("x", this.xPos, "y", this.yPos);

      //  console.warn(stepsAhead);
      //  return stepsAhead;
    } else {
      // Ludwig findet den Weg nicht und hat keinen Bock mehr, es weiter zu versuchen.
      this.isGivingAFuck = false;
      return false;
    }
  }
  findPath(change, goal) {
    // Ludwig versucht, auf einer Achse in beide Richtungen soweit zu gehen, bis er sich auf der anderen Achse in die richtige Richtung bewegen kann.

    let plus = true;
    let minus = true;
    for (let i = 0; i < 200; i++) {
      //if (plus) {
      plus = this.tryPath(change, goal);
      //}
      if (plus) {
        return plus;
      }
      //if (minus) {
      minus = this.tryPath({ x: change.x * -1, y: change.y * -1 }, goal);
      //}
      if (minus) {
        return minus;
      }
      if (change.y != 0) {
        change.y += this._X * 1;
      } else {
        change.x += this._X * 1;
      }
      /*    if (!plus && !minus) {
        return false;
      }*/
    }
  }
  tryPath(change, goal) {
    if (this.canMoveTo(change)) {
      let tryChange = change;
      if (tryChange.y != 0) {
        tryChange.x = this._X * goal;
      } else {
        tryChange.y = this._X * goal;
      }
      if (this.canMoveTo(tryChange)) {
        console.warn(change);
        return change;
      }
      return false;
    } else {
      //  return false;
    }
  }
  adjustWalkingSpeed(change) {
    // Ludwig sollte zumindest den Anschein machen, langsamer zu gehen, je weiter er von der Kamera entfernt ist. Sonst könnte es unnatürlich aussehen.
    if (change.x && change.y) {
      change.x =
        change.x > 0
          ? this.calcPerspective(this._X * 1.5, this.d)
          : this.calcPerspective(this._X * -1.5, this.d);
      change.y =
        change.y > 0
          ? this.calcPerspective(this._X * 0.75, this.d)
          : this.calcPerspective(this._X * -0.75, this.d);
    } else {
      change.x = this.calcPerspective(change.x, this.d);
      change.y = this.calcPerspective(change.y, this.d);
    }
    return change;
  }
  setDirection(change) {
    // Ludwig musste als Kind auf die harte Art lernen, in die Richtung zu schauen, in die er geht. Er achtet deshalb besonders genau darauf.
    if (change.y > 0) {
      this.direction = 0; //0 front / 1 left / 2 right / 3 back
    } else if (change.y < 0) {
      this.direction = 3; //0 front / 1 left / 2 right / 3 back
    } else if (change.x > 0) {
      this.direction = 2;
    } else if (change.x < 0) {
      this.direction = 1;
    }
  }
  calcNewPosition(change) {
    // Ludwig berechnet genau, wo er sich beim beim nächsten Schritt befinden muss
    return {
      x: this.xPos + this.calcPerspective(change.x, this.d),
      y: this.yPos + this.calcPerspective(change.y, this.d),
    };
  }
  calcBottomFromTop(x, y) {
    console.log(x, y);
  }
  take() {
    console.warn("TODO: Animation");
  }
  lookLeft() {
    this.draw(4, 1);
  }
  lookRight() {
    this.draw(4, 2);
  }
  lookFront() {
    this.draw(3, 0);
  }
  lookBack() {
    this.draw(5, 3);
  }
  stop() {
    // Ludwig stoppt all seine Bewegungen
    this.lookFront();
    cancelAnimationFrame(this.animation);
    this.moving = false;
  }
  calcPerspective(val, depthAtPoint) {
    // Ludwig will weder zu gross, noch zu klein wirken und berechnet deshalb seine Grösse anhand seiner Position.
    return val * (0.5 * depthAtPoint + 0.5);
  }

  reverseCalcPerspective(val, sizeAtPoint) {
    // Ludwig braucht diese Funktion wahrscheinlich nicht mehr.
    return (sizeAtPoint / val - 0.5) / 0.5;
  }

  hint() {
    // Ludwig muss sich bemerkbar machen. Dazu zeichnet seine Aussenlinie in einer grellen Farbe nach.
    this.ctx.beginPath();

    let startX =
      this.polygon[0].x * this.trueImgSize.width +
      this.trueImgSize.offsetX +
      this.xPos;
    let startY =
      this.polygon[0].y * this.trueImgSize.height +
      this.trueImgSize.offsetY +
      this.yPos;
    this.ctx.moveTo(startX, startY);

    for (let i = 1; i < this.polygon.length; i++) {
      let x =
        this.polygon[i].x * this.trueImgSize.width +
        this.trueImgSize.offsetX +
        this.xPos;
      let y =
        this.polygon[i].y * this.trueImgSize.height +
        this.trueImgSize.offsetY +
        this.yPos;
      this.ctx.lineTo(x, y);
    }

    this.ctx.closePath();
    this.ctx.lineWidth = 3;
    this.ctx.strokeStyle = "#f653a6";
    this.ctx.stroke();
  }
  get height() {
    // Ludwig gibt seine grösse an der aktuellen Standposition an
    return Math.ceil(
      this.calcPerspective(this.defaultHeight * this._X, this.d)
    );
  }
  get width() {
    // Ludwig gibt seine breite an der aktuellen Standposition an
    return Math.ceil(this.calcPerspective(this.defaultWidth * this._X, this.d));
  }
  get d() {
    let h = this.canvasheight * this._X;
    return (2 / h) * this.yPos;
  }
  get depth() {
    return this.d * this.canvasheight * this._X;
  }
  get isMoving() {
    return this.moving;
  }
  get pos() {
    return [this.xPos, this.yPos];
  }
  get givesAfuck() {
    return this.isGivingAFuck;
  }
  get isFindingPath() {
    return this.tempMove;
  }
  get polygon() {
    return [
      { x: 0.4795, y: 0.0 },
      { x: 0.3629, y: 0.0106 },
      { x: 0.3024, y: 0.0528 },
      { x: 0.3347, y: 0.1095 },
      { x: 0.3909, y: 0.1358 },
      { x: 0.3909, y: 0.1529 },
      { x: 0.2379, y: 0.1779 },
      { x: 0.1492, y: 0.2148 },
      { x: 0.0847, y: 0.3044 },
      { x: 0.0604, y: 0.4032 },
      { x: 0.0242, y: 0.4454 },
      { x: 0.0242, y: 0.4981 },
      { x: 0.0645, y: 0.5126 },
      { x: 0.0524, y: 0.5639 },
      { x: 0.0, y: 0.5863 },
      { x: 0.0604, y: 0.61 },
      { x: 0.121, y: 0.61 },
      { x: 0.1613, y: 0.5508 },
      { x: 0.2016, y: 0.4757 },
      { x: 0.2103, y: 0.4272 },
      { x: 0.2398, y: 0.4032 },
      { x: 0.2398, y: 0.5758 },
      { x: 0.2016, y: 0.5903 },
      { x: 0.1976, y: 0.6456 },
      { x: 0.1573, y: 0.672 },
      { x: 0.1653, y: 0.7299 },
      { x: 0.1653, y: 0.7629 },
      { x: 0.1331, y: 0.7747 },
      { x: 0.1734, y: 0.9447 },
      { x: 0.125, y: 0.975 },
      { x: 0.1935, y: 1.0 },
      { x: 0.3306, y: 1.0 },
      { x: 0.383, y: 0.942 },
      { x: 0.4032, y: 0.8353 },
      { x: 0.4315, y: 0.863 },
      { x: 0.4112, y: 0.9579 },
      { x: 0.4795, y: 0.9842 },
      { x: 0.5765, y: 0.9816 },
      { x: 0.5765, y: 0.9236 },
      { x: 0.6492, y: 0.8854 },
      { x: 0.6693, y: 0.8235 },
      { x: 0.7459, y: 0.7958 },
      { x: 0.7016, y: 0.7616 },
      { x: 0.7217, y: 0.6878 },
      { x: 0.7459, y: 0.6627 },
      { x: 0.7137, y: 0.6351 },
      { x: 0.7702, y: 0.5745 },
      { x: 0.8548, y: 0.5626 },
      { x: 0.8548, y: 0.5047 },
      { x: 1.0, y: 0.4085 },
      { x: 1.0, y: 0.3558 },
      { x: 0.9355, y: 0.2359 },
      { x: 0.8629, y: 0.1806 },
      { x: 0.6975, y: 0.1542 },
      { x: 0.6049, y: 0.1371 },
      { x: 0.6532, y: 0.1319 },
      { x: 0.7137, y: 0.1305 },
      { x: 0.7096, y: 0.0502 },
      { x: 0.6371, y: 0.0093 },
      { x: 0.5765, y: 0.0 },
      { x: 0.4795, y: 0.0 },
    ];
  }
  get trueImgSize() {
    let offsetX = 46;
    let offsetY = 13;
    let height = 303;
    let width = 98;
    let relH = this.height / this.spriteHeight;
    let relW = this.width / this.spriteWidth;
    let realHeigth = height * relH * this._X;
    let realWidth = width * relW * this._X;
    let realOffsetX = offsetX * relH * this._X;
    let realOffsetY = offsetY * relW * this._X;

    return {
      offsetX: realOffsetX,
      offsetY: realOffsetY,
      width: realWidth,
      height: realHeigth,
    };
  }
}
